
// Core
import React, { lazy, useEffect, useState } from 'react';
import {
    Card, Row, Col, Table, Spin, Select, Modal, notification, Form, Input, Button,
} from 'antd';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Moment from 'moment';
import 'moment/locale/es-mx';
import { SearchOutlined } from '@ant-design/icons';

// App
import {
    pacienteServicioListAction
} from '../../../redux/clinica/pacientes/actionCreator';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { TableWrapper } from '../../styled';
import { StyledTable } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { TipoTransaccion } from './../../../config/api/enums';
import FormCobroConceptoComponent from './FormCobroConcepto';

const { Search } = Input;

const PacienteConceptosView = ({ pacienteId, tipoTransaccionId, vista = '' }) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.responseReducer.loading);
    const registros = useSelector(state => state.PacienteReducer.compras);
    const registro = useSelector(state => state.PacienteReducer.compra);
    const catalogoFormasPago = useSelector(state => state.CatalogosReducer.formasPago);
    const [modalVisible, setModalVisible] = useState(false);
    const [compra, setCompra] = useState({});
    const [tableColumns, setTableColumns] = useState([]);
    const dataSource = [];
    const [form] = Form.useForm();

    useEffect(() => {
        if (vista === 'historial') { // Cuando se visualiza el historial clinico, solo mostrar los servicios odontologicos
            tipoTransaccionId = TipoTransaccion.NotaEvolucion;
        }
        dispatch(pacienteServicioListAction(pacienteId, tipoTransaccionId));
    }, [dispatch]);

    useEffect(() => {
        // Columnas para cuando es presupuesto
        const columns = [
            {
                title: 'Fecha',
                dataIndex: 'fecha_ejecucion',
                key: 'fecha_ejecucion',
            },
            {
                title: 'Concepto',
                dataIndex: 'servicio',
                key: 'servicio',
            },
            {
                title: 'Subtotal',
                dataIndex: 'subtotal',
                key: 'subtotal',
            },
            {
                title: 'Descuento',
                dataIndex: 'descuento',
                key: 'descuento',
            },
            {
                title: 'Total',
                dataIndex: 'total',
                key: 'total',
            },
            {
                title: 'Acciones',
                dataIndex: 'action',
                key: 'action',
                className: 'noprint'
            },
        ];
        switch (vista) {
            case "presupuesto":
                setTableColumns(columns);
                break;
            case "historial":
                setTableColumns([
                    {
                        title: 'Fecha',
                        dataIndex: 'fecha_ejecucion',
                        key: 'fecha_ejecucion',
                    },
                    {
                        title: 'Concepto',
                        dataIndex: 'servicio',
                        key: 'servicio',
                    },
                    {
                        title: 'Diente',
                        dataIndex: 'diente',
                        key: 'diente',
                    },
                    {
                        title: 'Tratamiento',
                        dataIndex: 'tratamiento',
                        key: 'tratamiento',
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                    },
                    {
                        title: 'Acciones',
                        dataIndex: 'action',
                        key: 'action',
                        className: 'noprint'
                    },
                ]);
                break;
            case "caja":
                setTableColumns([
                    {
                        title: 'Fecha',
                        dataIndex: 'fecha_ejecucion',
                        key: 'fecha_ejecucion',
                    },
                    {
                        title: 'Concepto',
                        dataIndex: 'servicio',
                        key: 'servicio',
                    },
                    {
                        title: '+ Subtotal',
                        dataIndex: 'subtotal',
                        key: 'subtotal',
                    },
                    {
                        title: '- Descuento',
                        dataIndex: 'descuento',
                        key: 'descuento',
                    },
                    {
                        title: '= Total',
                        dataIndex: 'total',
                        key: 'total',
                    },
                    {
                        title: '- Pagado',
                        dataIndex: 'abonos',
                        key: 'abonos',
                    },
                    {
                        title: '= Saldo',
                        dataIndex: 'saldo',
                        key: 'saldo',
                    },
                    /*{
                        title: 'Acciones',
                        dataIndex: 'action',
                        key: 'action',
                        className: 'noprint'
                    },*/
                ]);
                break;
            default:
                setTableColumns(columns);
        }



    }, [vista]);

    const detalleContent = () => {
        return (<>
            <StyledTable>
                <tbody>
                    <tr>
                        <td><strong>Fecha:</strong></td>
                        <td>{compra.fecha_ejecucion}</td>
                        <td><strong>Tipo transacción:</strong></td>
                        <td>{compra.tipo_transaccion}</td>
                    </tr>
                    <tr>
                        <td><strong>Categoria:</strong></td>
                        <td>{compra.categoria}</td>
                        <td><strong>Concepto:</strong></td>
                        <td>{compra.servicio}</td>
                    </tr>
                    <tr>
                        <td><strong>Subtotal:</strong></td>
                        <td>{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }).format(compra.subtotal)}</td>
                        <td><strong>Descuento:</strong></td>
                        <td>{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }).format(compra.descuento)}</td>
                    </tr>
                    <tr>
                        <td><strong>Total:</strong></td>
                        <td>{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }).format(compra.total)}</td>
                        <td><strong>Saldo pendiente:</strong></td>
                        <td>{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }).format(compra.saldo)}</td>
                    </tr>
                    <tr>
                        <td><strong>Dentista:</strong></td>
                        <td>{compra.dentista}</td>
                        <td><strong>Tratamiento realizado:</strong></td>
                        <td>
                            <u>Diente: </u>{compra.diente ?? '---'} <br />
                            <u>Procedimiento: </u>{compra.tratamiento ?? '---'}<br />
                            <u>Próximo tratamiento: </u>{compra.proximo_tratamiento ?? '---'}
                            <br />

                        </td>
                    </tr>
                </tbody>
            </StyledTable>
        </>)
    }

    const hideModal = async () => {
        setModalVisible(false);
    };

    const showModal = (record) => {
        setCompra(record);
        setModalVisible(true);
    }

    const renderFormularioPagos = (record) => {
        let rowContent = {}

        if (vista === "caja") {
            rowContent = {
                expandedRowKeys: dataSource.map(o => o.key),
                expandIcon: ({ expanded }) => { <></> },
                expandedRowRender: (record) => (
                    <FormCobroConceptoComponent record={record} />
                ),
            }
        }
        return rowContent;
    }

    const renderSaldo = (saldo) => {
        let elSaldo = <><span>$ {parseFloat(saldo).toFixed(2)}<br /><small style={{fontSize:'9px', color: 'red'}}>El cliente debe</small></span></>
        if (saldo <= 0) {
            const saldoAux = saldo * -1;
            elSaldo = <><span>$ {parseFloat(saldoAux).toFixed(2)}<br /><small style={{fontSize:'9px', color: 'green'}}>A favor del cliente</small></span></>
        }
            
        return elSaldo;
    }

    if (registros?.conceptos?.length)
        registros.conceptos.map((record, key) => {
            const { id, idPaciente, fecha_registro, fecha_ejecucion, idServicio, categoria, servicio, subtotal, descuento, total, abonos, saldo, tipo_transaccion, diente, tratamiento, proximo_tratamiento } = record;
            const keyR = Math.floor(Math.random() * 999);;
            let newRecord = {};
            newRecord.record = record;
            newRecord.key = keyR;

            let baseActions = (<div style={{ textAlign: 'right' }}>
                <Button size="small" type="primary" onClick={() => showModal(record)} className='noprint'>
                    Ver detalles
                </Button>

            </div>);

            /*if (vista === "caja") {
                baseActions = (<div style={{ textAlign: 'right' }}>
                    <Button size="small" type="primary" onClick={() => showModal(record)}>
                        Aplicar descuento
                    </Button>{' '}
                    <Button size="small" type="primary" onClick={() => showModal(record)}>
                        Ver detalles
                    </Button>

                </div>);
            }*/

            return dataSource.push({
                key: keyR,
                id,
                idPaciente,
                fecha_registro: new Intl.DateTimeFormat('es-MX', {
                    dateStyle: 'medium',
                    timeStyle: 'short',
                }).format(new Date(fecha_registro)),
                fecha_ejecucion: new Intl.DateTimeFormat('es-MX', {
                    dateStyle: 'medium',
                    timeStyle: 'short',
                }).format(new Date(fecha_ejecucion)),
                idServicio,
                servicio,
                diente,
                tratamiento,
                proximo_tratamiento,
                subtotal: <span>$ {parseFloat(subtotal).toFixed(2)}</span>,
                descuento: <span>$ {parseFloat(descuento).toFixed(2)}</span>,
                total: <span>$ {parseFloat(total).toFixed(2)}</span>,
                abonos: <span>$ {abonos ? parseFloat(abonos).toFixed(2) : '0.00'}</span>,
                saldo: renderSaldo(saldo),
                action: baseActions,
            });
        });


    return (
        <>
            <Card>
                <Row gutter={24}>
                    <Col className="w-100" md={24}>
                        <Cards headless>
                            {isLoading ? (
                                <div className="spin">
                                    <Spin />
                                </div>
                            ) : (
                                <div>
                                    <TableWrapper className="table-data-view table-responsive">
                                        <Table
                                            key='table-data'
                                            pagination={false}
                                            dataSource={dataSource}
                                            columns={tableColumns}
                                            locale={{ emptyText: 'Sin registros' }}
                                            size='small'
                                            bordered={true}
                                            expandable={renderFormularioPagos()}

                                        />
                                    </TableWrapper>
                                </div>
                            )}
                        </Cards>
                    </Col>
                </Row>
            </Card>
            <Modal title='' visible={modalVisible} onCancel={hideModal} footer={[]} width='80%'>
                {detalleContent()}
            </Modal>
        </>
    );
};

export default PacienteConceptosView;
